import React, { memo } from 'react';

import Content from '../../../../components/Content';
import Slider3D from '../../../../components/Slider3D';

import { Container, Title } from './styles';

const LatestLessons = ({ latestLessons, showSpinner }) => {
  return (
    <Container className="latest-lessons">
      <Content>
        <Title>Descomplicando o canto</Title>
        <Slider3D
          route="aula"
          lessons={latestLessons}
          loading={showSpinner}
        />
      </Content>
    </Container>
  );
};

export default memo(LatestLessons);
